module.exports = __webpack_public_path__ + "fonts/OpenSans-LightItalic.5c3b2e2d.woff2";